export enum PORTALTYPE {
    ADMIN = 'admin',
};